import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveryParameters, TicketActionType, AddressBookQuery, GameQuery, TicketQuery, ErrorStateService, TicketService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressBookModule } from '@fgb/portal-component-library/src/lib/user/address-book';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { GameBannerModule } from '@fgb/portal-component-library/src/lib/tickettransfer/game-banner';
import { SelectedTicketsTableModule } from '@fgb/portal-component-library/src/lib/tickettransfer/selected-tickets-table';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@fgb/core';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/tickettransfer/game-banner';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/tickettransfer/selected-tickets-table';
import * as ɵngcc7 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc8 from '@angular/common';
import * as ɵngcc9 from '@fgb/portal-component-library/src/lib/shared/loading';
import * as ɵngcc10 from '@fgb/portal-component-library/src/lib/user/address-book';
import * as ɵngcc11 from '@ngx-translate/core';

function TransferFormComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngb-highlight", 13);
    ɵngcc0.ɵɵtext(1, " - ");
    ɵngcc0.ɵɵelement(2, "ngb-highlight", 13);
} if (rf & 2) {
    const r_r6 = ctx.result;
    const t_r7 = ctx.term;
    ɵngcc0.ɵɵproperty("result", r_r6.FullName)("term", t_r7);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("result", r_r6.EmailAddress)("term", t_r7);
} }
function TransferFormComponent_ng_template_23_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "cl.transfer.form.confirm.modal.button.confirm.transfer"));
} }
function TransferFormComponent_ng_template_23_span_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "fgbcl-loading", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("size", "small");
} }
function TransferFormComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelement(1, "fgbcl-game-banner");
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelementStart(4, "p", 17);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementStart(7, "span", 18);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "fgbcl-selected-tickets-table");
    ɵngcc0.ɵɵelement(10, "fgbcl-errors");
    ɵngcc0.ɵɵelementStart(11, "button", 19);
    ɵngcc0.ɵɵlistener("click", function TransferFormComponent_ng_template_23_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.transferTicket(); });
    ɵngcc0.ɵɵtemplate(12, TransferFormComponent_ng_template_23_span_12_Template, 3, 3, "span", 20);
    ɵngcc0.ɵɵtemplate(13, TransferFormComponent_ng_template_23_span_13_Template, 2, 1, "span", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 21);
    ɵngcc0.ɵɵlistener("click", function TransferFormComponent_ng_template_23_Template_button_click_14_listener() { const modal_r8 = ctx.$implicit; return modal_r8.dismiss("Cross click"); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 7, "cl.transfer.form.confirm.modal.text"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.email);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 9, "cl.transfer.form.confirm.modal.button.cancel.transfer"), " ");
} }
function TransferFormComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵelementStart(2, "h4", 24);
    ɵngcc0.ɵɵtext(3, "Contacts");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 25);
    ɵngcc0.ɵɵlistener("click", function TransferFormComponent_ng_template_25_Template_button_click_4_listener() { const modal_r14 = ctx.$implicit; return modal_r14.dismiss("Cross click"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 26);
    ɵngcc0.ɵɵelementStart(6, "fgbcl-address-book", 27);
    ɵngcc0.ɵɵlistener("selectedContact", function TransferFormComponent_ng_template_25_Template_fgbcl_address_book_selectedContact_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.setContactDetails($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
class TransferFormComponent {
    constructor(modalService, router, addressBookQuery, gameQuery, ticketQuery, errorStateService, ticketService) {
        this.modalService = modalService;
        this.router = router;
        this.addressBookQuery = addressBookQuery;
        this.gameQuery = gameQuery;
        this.ticketQuery = ticketQuery;
        this.errorStateService = errorStateService;
        this.ticketService = ticketService;
        this.loading = false;
        this.subscription = new Subscription();
        this.selectedTicketsSubscription = new Subscription();
        this.searchFullName = (text$) => text$.pipe(debounceTime(200), map((term) => term === ''
            ? []
            : this.addressBookQuery
                .getAll()
                .filter((v) => v.FullName.toLowerCase().indexOf(term.toLowerCase()) > -1)
                .slice(0, 10)));
        this.formatter = (searchText) => {
            const address = searchText;
            if (this._isAddressBook(address)) {
                this.email = address.EmailAddress;
                return address.FullName;
            }
            else {
                return searchText;
            }
        };
    }
    ngOnInit() {
        let game = this.gameQuery.getActive();
        this.selectedGameNumber = game.GameNumber;
    }
    validate(content) {
        if (this.validateEmail()) {
            this.open(content);
        }
        else {
            this.error = '*Error: Email must be in the correct format';
        }
    }
    validateEmail() {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.email).toLowerCase());
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then((result) => { }, (reason) => { });
    }
    transferTicket() {
        this.loading = true;
        let deliveryParameters = new DeliveryParameters();
        deliveryParameters.EmailAddress = this.email;
        deliveryParameters.TicketAction = TicketActionType.TransferToEmail;
        if (this._isAddressBook(this.fullName)) {
            const addressBook = this.fullName;
            deliveryParameters.FirstName = addressBook.FullName;
        }
        else {
            deliveryParameters.FirstName = this.fullName;
        }
        this.subscription = this.ticketService.transferTicket(deliveryParameters).subscribe((result) => {
            if (result && result.length > 0) {
                if (result[0].Result.ErrorNumber === 0) {
                    let selectedTickets = this.ticketQuery.getAll({ filterBy: (ticket) => ticket.selected });
                    selectedTickets.map((ticket) => this.ticketService.setTransferredTicket(ticket.Id, deliveryParameters.EmailAddress));
                    this.modalService.dismissAll();
                    this.router.navigate(['ticketTransfer/success']);
                }
                else {
                    this.errorStateService.addError(`Error: Transfer failed. Description: ${result[0].Result.ErrorDescription}`);
                    setTimeout(() => {
                        this.errorStateService.clearErrors();
                        this.loading = false;
                    }, 3000);
                }
            }
            else {
                this.errorStateService.addError(`Error: Transfer failed.`);
                setTimeout(() => {
                    this.errorStateService.clearErrors();
                    this.loading = false;
                }, 3000);
            }
        });
    }
    setContactDetails(item) {
        this.email = item.EmailAddress;
        this.fullName = item.FullName;
        this.modalService.dismissAll();
    }
    _isAddressBook(item) {
        return item.FullName !== undefined;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.selectedTicketsSubscription.unsubscribe();
    }
}
TransferFormComponent.ɵfac = function TransferFormComponent_Factory(t) { return new (t || TransferFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.AddressBookQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.GameQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TicketQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TicketService)); };
TransferFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TransferFormComponent, selectors: [["fgbcl-transfer-form"]], decls: 27, vars: 19, consts: [[1, "form-group", "d-flex", "justify-content-between"], ["type", "text", "placeholder", "Full Name", 1, "form-control", "bg-muted", 3, "ngModel", "ngbTypeahead", "inputFormatter", "resultTemplate", "ngModelChange"], ["type", "email", "placeholder", "Email Address", 1, "d-none", "d-md-block", "bg-muted", "form-control", 3, "ngModel", "ngModelChange"], ["type", "email", "placeholder", "Email Address", 1, "d-block", "d-md-none", "bg-muted", "form-control", 3, "ngModel", "ngModelChange"], ["nameWithEmail", ""], [1, "error", "text-danger", "d-block"], ["type", "button", 1, "btn", "btn-dark", "mb-3", "w-100", 3, "click"], ["type", "button", 1, "btn", "ticket-transfer-button", 3, "disabled", "routerLink"], [1, "icon", "material-icons", "float-left"], [1, "btn", "btn-primary", "ticket-transfer-button", 3, "disabled", "click"], [1, "icon", "material-icons", "float-right"], ["transferTicketModal", ""], ["contactBookModal", ""], [3, "result", "term"], [1, "modal-body"], [1, "container"], [1, "text-center", "p-3"], [1, "mb-4"], [1, "text-primary", "font-weight-bold", "d-block"], [1, "ticket-transfer-confirm-transfer-button", "text-white", "bg-primary", "d-block", 3, "disabled", "click"], [4, "ngIf"], [1, "ticket-transfer-cancel-transfer-button", "d-block", "text-primary", 3, "disabled", "click"], [3, "size"], [1, "modal-header"], ["id", "modal-basic-title", 1, "modal-title"], ["type", "button", "aria-label", "Close modal", 1, "close", "icon-cancel-circle", "modal-close-icon", 3, "click"], [1, "p-3"], [3, "selectedContact"]], template: function TransferFormComponent_Template(rf, ctx) { if (rf & 1) {
        const _r18 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function TransferFormComponent_Template_input_ngModelChange_1_listener($event) { return ctx.fullName = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function TransferFormComponent_Template_input_ngModelChange_2_listener($event) { return ctx.email = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 0);
        ɵngcc0.ɵɵelementStart(4, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function TransferFormComponent_Template_input_ngModelChange_4_listener($event) { return ctx.email = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TransferFormComponent_ng_template_5_Template, 3, 4, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(7, "p", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 6);
        ɵngcc0.ɵɵlistener("click", function TransferFormComponent_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r18); const _r4 = ɵngcc0.ɵɵreference(26); return ctx.open(_r4); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "button", 7);
        ɵngcc0.ɵɵelementStart(14, "span", 8);
        ɵngcc0.ɵɵtext(15, "chevron_left");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "button", 9);
        ɵngcc0.ɵɵlistener("click", function TransferFormComponent_Template_button_click_18_listener() { ɵngcc0.ɵɵrestoreView(_r18); const _r2 = ɵngcc0.ɵɵreference(24); return ctx.validate(_r2); });
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementStart(21, "span", 10);
        ɵngcc0.ɵɵtext(22, "chevron_right");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, TransferFormComponent_ng_template_23_Template, 17, 11, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(25, TransferFormComponent_ng_template_25_Template, 7, 0, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.fullName)("ngbTypeahead", ctx.searchFullName)("inputFormatter", ctx.formatter)("resultTemplate", _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.email);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.email);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.error);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 13, "cl.transfer.form.choose.contacts"), "\n");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("routerLink", "/ticketTransfer/tickets/", ctx.selectedGameNumber, "");
        ɵngcc0.ɵɵproperty("disabled", !ctx.selectedGameNumber);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(17, 15, "cl.transfer.form.button.back"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.fullName || !ctx.email);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(20, 17, "cl.transfer.form.button.transfer.now"), "");
    } }, directives: [ɵngcc4.DefaultValueAccessor, ɵngcc1.NgbTypeahead, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc2.RouterLink, ɵngcc1.NgbHighlight, ɵngcc5.GameBannerComponent, ɵngcc6.SelectedTicketsTableComponent, ɵngcc7.ErrorsComponent, ɵngcc8.NgIf, ɵngcc9.LoadingComponent, ɵngcc10.AddressBookComponent], pipes: [ɵngcc11.TranslatePipe], styles: [".modal-header[_ngcontent-%COMP%]{margin-bottom:15px}.modal-body[_ngcontent-%COMP%]{padding:0}.form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:0;width:49%}.btn[_ngcontent-%COMP%]{width:150px}.error[_ngcontent-%COMP%]{font-size:11px}@media only screen and (max-width:768px){.form-group[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%}}"] });
TransferFormComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: Router },
    { type: AddressBookQuery },
    { type: GameQuery },
    { type: TicketQuery },
    { type: ErrorStateService },
    { type: TicketService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TransferFormComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-transfer-form',
                template: "<div class=\"form-group d-flex justify-content-between\">\r\n  <input\r\n    type=\"text\"\r\n    class=\"form-control bg-muted\"\r\n    placeholder=\"Full Name\"\r\n    [(ngModel)]=\"fullName\"\r\n    [ngbTypeahead]=\"searchFullName\"\r\n    [inputFormatter]=\"formatter\"\r\n    [resultTemplate]=\"nameWithEmail\"\r\n  />\r\n  <input type=\"email\" class=\"d-none d-md-block bg-muted form-control\" placeholder=\"Email Address\" [(ngModel)]=\"email\" />\r\n</div>\r\n\r\n<div class=\"form-group d-flex justify-content-between\">\r\n  <input type=\"email\" class=\"d-block d-md-none bg-muted form-control\" placeholder=\"Email Address\" [(ngModel)]=\"email\" />\r\n</div>\r\n\r\n<ng-template #nameWithEmail let-r=\"result\" let-t=\"term\">\r\n  <ngb-highlight [result]=\"r.FullName\" [term]=\"t\"></ngb-highlight>\r\n  -\r\n  <ngb-highlight [result]=\"r.EmailAddress\" [term]=\"t\"></ngb-highlight>\r\n</ng-template>\r\n\r\n<p class=\"error text-danger d-block\">{{ error }}</p>\r\n\r\n<button class=\"btn btn-dark mb-3 w-100\" type=\"button\" (click)=\"open(contactBookModal)\">\r\n  {{ 'cl.transfer.form.choose.contacts' | translate }}\r\n</button>\r\n\r\n<div class=\"form-group d-flex justify-content-between\">\r\n  <button\r\n    class=\"btn ticket-transfer-button\"\r\n    type=\"button\"\r\n    [disabled]=\"!selectedGameNumber\"\r\n    routerLink=\"/ticketTransfer/tickets/{{ selectedGameNumber }}\"\r\n  >\r\n    <span class=\"icon material-icons float-left\">chevron_left</span>\r\n    {{ 'cl.transfer.form.button.back' | translate }}\r\n  </button>\r\n  <button class=\"btn btn-primary ticket-transfer-button\" (click)=\"validate(transferTicketModal)\" [disabled]=\"!fullName || !email\">\r\n    {{ 'cl.transfer.form.button.transfer.now' | translate }}<span class=\"icon material-icons float-right\">chevron_right</span>\r\n  </button>\r\n</div>\r\n\r\n<!-- Modal -->\r\n<ng-template #transferTicketModal let-modal>\r\n  <div class=\"modal-body\">\r\n    <fgbcl-game-banner></fgbcl-game-banner>\r\n    <div class=\"container\">\r\n      <div class=\"text-center p-3\">\r\n        <p class=\"mb-4\">\r\n          {{ 'cl.transfer.form.confirm.modal.text' | translate }}\r\n          <span class=\"text-primary font-weight-bold d-block\">{{ email }}</span>\r\n        </p>\r\n        <fgbcl-selected-tickets-table></fgbcl-selected-tickets-table>\r\n        <fgbcl-errors></fgbcl-errors>\r\n        <button\r\n          (click)=\"transferTicket()\"\r\n          class=\"ticket-transfer-confirm-transfer-button text-white bg-primary d-block\"\r\n          [disabled]=\"loading\"\r\n        >\r\n          <span *ngIf=\"!loading\">{{ 'cl.transfer.form.confirm.modal.button.confirm.transfer' | translate }}</span>\r\n          <span *ngIf=\"loading\"><fgbcl-loading [size]=\"'small'\"></fgbcl-loading></span>\r\n        </button>\r\n        <button\r\n          (click)=\"modal.dismiss('Cross click')\"\r\n          class=\"ticket-transfer-cancel-transfer-button d-block text-primary\"\r\n          [disabled]=\"loading\"\r\n        >\r\n          {{ 'cl.transfer.form.confirm.modal.button.cancel.transfer' | translate }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<!-- Modal -->\r\n<ng-template #contactBookModal let-modal>\r\n  <div class=\"modal-body\">\r\n    <div class=\"modal-header\">\r\n      <h4 class=\"modal-title\" id=\"modal-basic-title\">Contacts</h4>\r\n      <button\r\n        type=\"button\"\r\n        class=\"close icon-cancel-circle modal-close-icon\"\r\n        aria-label=\"Close modal\"\r\n        (click)=\"modal.dismiss('Cross click')\"\r\n      ></button>\r\n    </div>\r\n    <div class=\"p-3\">\r\n      <fgbcl-address-book (selectedContact)=\"setContactDetails($event)\"></fgbcl-address-book>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
                styles: [".modal-header{margin-bottom:15px}.modal-body{padding:0}.form-group input{border:0;width:49%}.btn{width:150px}.error{font-size:11px}@media only screen and (max-width:768px){.form-group input{width:100%}}"]
            }]
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc2.Router }, { type: ɵngcc3.AddressBookQuery }, { type: ɵngcc3.GameQuery }, { type: ɵngcc3.TicketQuery }, { type: ɵngcc3.ErrorStateService }, { type: ɵngcc3.TicketService }]; }, null); })();

class TransferFormModule {
}
TransferFormModule.ɵfac = function TransferFormModule_Factory(t) { return new (t || TransferFormModule)(); };
TransferFormModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TransferFormModule });
TransferFormModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgbModule,
            FormsModule,
            RouterModule,
            ReactiveFormsModule,
            AddressBookModule,
            GameBannerModule,
            SelectedTicketsTableModule,
            ErrorsModule,
            LoadingModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TransferFormModule, { declarations: function () { return [TransferFormComponent]; }, imports: function () { return [CommonModule,
        NgbModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AddressBookModule,
        GameBannerModule,
        SelectedTicketsTableModule,
        ErrorsModule,
        LoadingModule, ɵngcc11.TranslateModule]; }, exports: function () { return [TransferFormComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TransferFormModule, [{
        type: NgModule,
        args: [{
                declarations: [TransferFormComponent],
                imports: [
                    CommonModule,
                    NgbModule,
                    FormsModule,
                    RouterModule,
                    ReactiveFormsModule,
                    AddressBookModule,
                    GameBannerModule,
                    SelectedTicketsTableModule,
                    ErrorsModule,
                    LoadingModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [TransferFormComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TransferFormComponent, TransferFormModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-transfer-form.js.map